import { SELECTED_EMPRESA_CHANGED } from '../actions/entrega-por-empresa.action'

const initialSystenState = {
  empresaId: '',
}

export default function (state = initialSystenState, action) {
  switch (action.type) {
    case SELECTED_EMPRESA_CHANGED:
      const { empresaId } = action.payload
      return {
        ...state,
        empresaId,
      }
    default:
      return state
  }
}
